  <div *ngFor="let filter of filterData; let last = last">
    <h5>{{ filter.FilterTitle }}</h5>
    <div class="filter-values">
        <div class="filter-checkbox" *ngFor="let filterOption of filter.filterlist">
          <input
            type="checkbox"
            class="form-check-input"
            [(ngModel)]='filterOption.isSelected'
            (click)="filterSelected(filter.filter_subject, filterOption)"
          />
          <label
            [for]="filterOption.filterValue + filterOption.filterId"
            [title]="filterOption.filterValue"
          >{{ filterOption.filterValue }}</label>
        </div>
    </div>
    <hr *ngIf="!last" style="border-bottom: 2px solid #dddddd;" />
  </div>
